import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a33b3e82baf1dbe7192ded875980b5166b from "./generated-e08867b3-f6f2-4856-b3e6-b9ffed73f559.json";

import ac801af05002e429c59546b5b7d041ef1b from "./generated-2cc022e5-0d7f-4868-8b3e-fc7b844cc8a0.json";

import a5bf05dae3be472b4cf5ff82e756945f9b from "./generated-512bc5ab-cc1d-4b2b-82e8-011afa41055e.json";

import a9740d6ece34b6ddbcfc6e8fdf68ad4b3b from "./generated-8557b9ca-b639-41b3-906d-e6eea1a6555c.json";

import ac0c5c834ae25927dc019738d601f6452b from "./generated-045c9d42-3719-43ce-ab5d-8eaf07dc51db.json";

import a40bdd90ec4a6b93c70dbe881ffd306f9b from "./generated-270ae332-953a-4cd4-bb0c-cf09abc784ed.json";

import af6520146c4de2c482af3eddcbc66ddf0b from "./generated-dd4c2dd6-d71f-4c67-a680-427849c7269f.json";

import a83661e68112bdae6630ea9e1c35b101db from "./generated-a5cf8685-9d43-4247-808f-ab4e0a747523.json";

import ab29de8b2580a98c22d2ac6930cd57bbfb from "./generated-9f5dd59c-993b-479a-8447-e0fc1aa586a5.json";

import a1423ed51a711421fb5cbc3fb1c67c5afb from "./generated-e0cab031-9f5f-49d6-96f1-cbf2bbef0376.json";

import a9df55f1ef6ec845e52aa16fa7ab7f585b from "./generated-3b444fac-9e48-43e7-a722-cf0e25a6dad4.json";

import afebe463d1a056a1f8fa1e65b886c7ae0b from "./generated-b37c69e8-ecd3-4d67-9718-3c6edbc6e45e.json";

import ab4ed0fc367a5dcbd2d47aa1645b5bbe0b from "./generated-5f6433c9-6afa-401c-9b64-f040cdf8429f.json";

import a7ef2494b0950636bc06ca2acb0fc6268b from "./generated-5117e4d3-bc96-43fe-8cf6-96ec77c5aad8.json";

import aadc04a1e26041c690ddb962b28541948b from "./generated-e97bc697-a712-41c6-9a21-9e8cd280f857.json";

import a045aa0fa64a1e8f8049b4c094831fc1cb from "./generated-1a7dd3a0-cbf3-4b0d-900f-340deb8a5d88.json";

import abedece64ccc2b542b448de6fea75e43fb from "./generated-ace12145-f012-4835-9fd5-d632a3391ac6.json";

import aaa850b2da4e75827641f5765c73cf5a2b from "./generated-fdfc0611-f571-4333-b482-66ec90ebb1e8.json";

import a0a3278e2a82a38d2ed4e63679ec810cab from "./generated-6f1b5f6f-9734-4f94-a3a5-fdb726972091.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a33b3e82baf1dbe7192ded875980b5166b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(ac801af05002e429c59546b5b7d041ef1b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a5bf05dae3be472b4cf5ff82e756945f9b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a9740d6ece34b6ddbcfc6e8fdf68ad4b3b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ac0c5c834ae25927dc019738d601f6452b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a40bdd90ec4a6b93c70dbe881ffd306f9b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(af6520146c4de2c482af3eddcbc66ddf0b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a83661e68112bdae6630ea9e1c35b101db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(ab29de8b2580a98c22d2ac6930cd57bbfb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a1423ed51a711421fb5cbc3fb1c67c5afb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a9df55f1ef6ec845e52aa16fa7ab7f585b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(afebe463d1a056a1f8fa1e65b886c7ae0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(ab4ed0fc367a5dcbd2d47aa1645b5bbe0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a7ef2494b0950636bc06ca2acb0fc6268b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(aadc04a1e26041c690ddb962b28541948b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a045aa0fa64a1e8f8049b4c094831fc1cb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(abedece64ccc2b542b448de6fea75e43fb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(aaa850b2da4e75827641f5765c73cf5a2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a0a3278e2a82a38d2ed4e63679ec810cab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(abedece64ccc2b542b448de6fea75e43fb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */